import React, { useState, useEffect, useRef } from 'react';

import { getAsset } from '../../../../../../util/assets';

const AUTO_ADVANCE_INTERVAL = 4000;

const SLIDES = [
  {
    image: '/carousel-everyday-moments.png',
    text: 'Share everyday moments\nwith your loved ones',
  },
  {
    image: '/carousel-celebrate-life.png',
    text: 'Celebrate life with photos\nand videos from everyone',
  },
  {
    image: '/carousel-auto-delivery.png',
    text: "Automatic Delivery of the\nphotos you're in",
  },
  {
    image: '/carousel-qr-printables.png',
    text: 'Personalized QR Printables\n& SMS join codes',
  },
  {
    image: '/carousel-prints-postcards.png',
    text: 'Turn favorite photos into\nprints & postcards!',
  },
];

const RegistrationImageCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalRef = useRef(null);
  const slide = SLIDES[activeIndex];

  const startTimer = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveIndex(i => (i + 1) % SLIDES.length);
    }, AUTO_ADVANCE_INTERVAL);
  };

  useEffect(() => {
    startTimer();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    SLIDES.forEach(s => {
      const img = new Image();
      img.src = getAsset(s.image);
    });
  }, []);

  return (
    <div className="registration-carousel">
      <img
        src={getAsset('/confetti-transparent.png')}
        alt=""
        className="registration-carousel-confetti"
      />

      <div className="registration-carousel-content">
        <p className="registration-carousel-text">{slide.text}</p>

        <img
          src={getAsset(slide.image)}
          alt=""
          className="registration-carousel-image"
        />

        <div className="registration-carousel-dots">
          {SLIDES.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`registration-carousel-dot${i === activeIndex ? ' registration-carousel-dot--active' : ''}`}
              onClick={() => {
                setActiveIndex(i);
                startTimer();
              }}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RegistrationImageCarousel;
